import {
  type IncomingMessage,
  ListenerEvent,
  MessageHandler
} from '@carvana/merch-native';
import { useContext, useMemo } from 'react';
import UserContext from '~/context/common/UserContext';
import getGeoLocationApi from '~/services/common/getGeoLocationApi';

type UpdateGeolocationMessage<T> = IncomingMessage<
  T,
  {
    city?: string;
    state?: string;
    zip: string;
  }
>;

function isUpdateGeolocationMessage<T>(
  message: IncomingMessage<T, any>
): message is UpdateGeolocationMessage<T> {
  return (
    message.event === ListenerEvent.UpdateGeolocation &&
    message.payload.zip != null
  );
}

export default function useUpdateGeolocationHandler<T>(): MessageHandler<T> {
  const {
    location: { setData }
  } = useContext(UserContext);

  return useMemo(
    () =>
      new MessageHandler(
        isUpdateGeolocationMessage,
        (message: UpdateGeolocationMessage<T>) => {
          const geoLocationApi = getGeoLocationApi();

          geoLocationApi.setGeoLocation(message.payload.zip).then(location => {
            setData(location);
          });
        }
      ),
    [setData]
  );
}
